
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  isTextArea?: boolean;
  rows?: number;
}

export const Input: React.FC<InputProps> = ({ label, isTextArea, className = '', ...props }) => {
  // Reduced rounding from rounded-xl to rounded-lg
  const baseClasses = "w-full px-5 py-3 bg-white border border-slate-200 rounded-lg font-bold text-slate-900 outline-none focus:ring-4 focus:ring-slate-100 transition-all placeholder:text-slate-300";
  
  return (
    <div className="space-y-2">
      {label && <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest ml-1">{label}</label>}
      {isTextArea ? (
        <textarea className={`${baseClasses} resize-none ${className}`} {...(props as any)} />
      ) : (
        <input className={`${baseClasses} ${className}`} {...(props as any)} />
      )}
    </div>
  );
};
